import React from 'react';

const DiscordSvg = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.947 2.418-2.157 2.418z" />
  </svg>
);

const SlackSvg = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zm1.271 0a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zm0 1.271a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zm10.122 2.521a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zm-1.268 0a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zm-2.523 10.122a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zm0-1.268a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" />
  </svg>
);

const PROVIDER_CONFIG = {
  discord: { color: '#5865F2', label: 'Discord', Icon: DiscordSvg },
  slack:   { color: '#E01E5A', label: 'Slack',   Icon: SlackSvg },
};

interface WebhookPillProps {
  provider: 'discord' | 'slack';
  channelUrl?: string | null;
  variant?: 'pill' | 'icon';
}

export const WebhookPill = ({ provider, channelUrl, variant = 'pill' }: WebhookPillProps) => {
  const { color, label, Icon } = PROVIDER_CONFIG[provider];
  const isIcon = variant === 'icon';
  const iconSize = isIcon ? 14 : 12;

  const style = { color, backgroundColor: `${color}1A` };
  const hoverStyle = { backgroundColor: `${color}26` };

  const baseClass = isIcon
    ? 'inline-flex items-center justify-center w-[24px] h-[24px] rounded-full flex-shrink-0 transition-all'
    : 'inline-flex items-center gap-[5px] px-[10px] py-[3px] rounded-[5px] text-[12px] font-semibold transition-all';

  const titleText = channelUrl ? `Open ${label} channel` : `Connected to ${label}`;

  if (channelUrl) {
    return (
      <a
        href={channelUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={baseClass}
        style={style}
        title={titleText}
        onClick={(e) => e.stopPropagation()}
        onMouseEnter={(e) => Object.assign((e.currentTarget as HTMLElement).style, hoverStyle)}
        onMouseLeave={(e) => Object.assign((e.currentTarget as HTMLElement).style, { backgroundColor: `${color}1A` })}
      >
        <Icon size={iconSize} />
        {!isIcon && label}
      </a>
    );
  }

  return (
    <span className={baseClass} style={style} title={titleText}>
      <Icon size={iconSize} />
      {!isIcon && label}
    </span>
  );
};

// Backwards-compatible alias
export const DiscordPill = ({ channelUrl, variant }: { channelUrl?: string | null; variant?: 'pill' | 'icon' }) => (
  <WebhookPill provider="discord" channelUrl={channelUrl} variant={variant} />
);
